// Localized, DOM-built fallback shown when a stale chunk fails right after an auto-reload.
const MSG: Record<string, [string, string]> = {
  en: ['A new version of the site is available.', 'Reload the page'],
  fr: ['Une nouvelle version du site est disponible.', 'Recharger la page'],
  es: ['Hay una nueva versión del sitio disponible.', 'Recargar la página'],
  de: ['Eine neue Version der Website ist verfügbar.', 'Seite neu laden'],
  it: ['È disponibile una nuova versione del sito.', 'Ricarica la pagina'],
  pt: ['Uma nova versão do site está disponível.', 'Recarregar a página'],
  nl: ['Er is een nieuwe versie van de site beschikbaar.', 'Pagina opnieuw laden'],
  ar: ['يتوفر إصدار جديد من الموقع.', 'إعادة تحميل الصفحة'],
  zh: ['网站有新版本可用。', '重新加载页面'],
  ja: ['サイトの新しいバージョンが利用可能です。', 'ページを再読み込み'],
  ko: ['사이트의 새 버전을 사용할 수 있습니다.', '페이지 새로고침'],
  ru: ['Доступна новая версия сайта.', 'Перезагрузить страницу'],
  tr: ['Sitenin yeni bir sürümü mevcut.', 'Sayfayı yenile'],
  pl: ['Dostępna jest nowa wersja strony.', 'Odśwież stronę'],
};
export function fallbackLang(pathname: string): string {
  const seg = (pathname.split('/')[1] || '').toLowerCase();
  return MSG[seg] ? seg : 'en';
}
export function renderChunkFallback(root: HTMLElement, pathname: string): void {
  const lang = fallbackLang(pathname);
  const [text, link] = MSG[lang];
  const box = document.createElement('div');
  box.setAttribute('lang', lang);
  if (lang === 'ar') box.setAttribute('dir', 'rtl');
  box.style.cssText = 'padding:3rem 1.5rem;text-align:center;font-family:system-ui,sans-serif';
  const p = document.createElement('p'); p.textContent = text;
  const a = document.createElement('a');
  // Same-origin path only (no query/hash), so no injection and no auto-loop.
  a.href = pathname.startsWith('/') && !pathname.startsWith('//') ? pathname : '/';
  a.textContent = link;
  const p2 = document.createElement('p'); p2.appendChild(a);
  box.append(p, p2);
  root.replaceChildren(box);
}
